import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-notes',
  templateUrl: './icon-notes.component.html',
  styleUrls: ['./icon-notes.component.scss']
})
export class IconNotesComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
